import React from 'react'
import PropTypes from 'prop-types'

import { Text } from 'shared/components'

export const ContributorColumnComponent = ({ value }) => {
  if (value.length === 0) {
    return <Text size={11}>-</Text>
  }
  return <Text size={11}>{value[0].email}</Text>
}

ContributorColumnComponent.propTypes = {
  value: PropTypes.array.isRequired,
}

export default ContributorColumnComponent
